<template>
  <b-card class="bg-white rounded-xl px-2">
    <AddUpdatesPopup :isOpen="isPopupOpen" @close="togglePopup" />
    <div class="flex justify-between items-center">
      <div>
        <h2 class="text-2xl font-semibold">List of Friends Updates</h2>
      </div>

      <base-button
        outline
        class="px-6 py-1 mx-1"
        type="primary"
        @click="handleAdd"
      >
        <span class="btn-inner--text flex justify-between items-center"
          ><feather-icon icon="PlusIcon" class="cust-HW"></feather-icon>Add
          Updates</span
        >
      </base-button>
    </div>
    <UpdatesTable />
  </b-card>
</template>

<script>
import UpdatesTable from "./components/UpdatesTable.vue";
import AddUpdatesPopup from "./components/AddUpdatesPopup.vue";

export default {
  data() {
    return {
      isPopupOpen: false,
    };
  },
  components: {
    UpdatesTable,
    AddUpdatesPopup,
  },
  methods: {
    handleAdd() {
      this.$router.push({ name: "addFriendsUpdates" });
    },
    async togglePopup(val = false) {
      this.isPopupOpen = val;
    },
  },
};
</script>
<style>
.txt-color {
  color: #4f0a4b;
}
</style>
